import uiConfig from 'src/lib/ui/config';
import { animate, ImageCoverView } from '@play-co/timestep-core/ui';
import ResponsiveScene from './ResponsiveScene';
import StateObserver from 'src/StateObserver';
import { Pet } from 'src/replicant/buruburu/pet';
import { Transition } from 'src/game/logic/SceneManager';
import { getSceneManager, getScreenTop, waitForItPromise } from 'src/lib/utils';
import { isSceneEntered } from 'src/lib/stateUtils';
import statePromise from 'src/lib/statePromise';
import { getPet } from '../pet';
import {
  isNativeAppAvailable,
  isNativePromoAvailable,
} from '../native/native.util';
import NativeAppPromoButton from '../native/NativeAppPromoButton';

export default class LivingRoomScene extends ResponsiveScene {
  constructor() {
    super(
      new ImageCoverView({
        ...uiConfig.buruburu.backgroundDefaults,
        ...uiConfig.buruburu.livingRoom,
      }),
    );

    this.getView().tag = 'livingRoom';

    this.createNativeAppButton();
  }

  async showScene() {
    const { user } = StateObserver.getState();
    if (Pet.getters(user).getCurrentEvolution()) {
      await statePromise(() => isSceneEntered('livingRoom'));
      await waitForItPromise(500);
      getPet().position.setWandering(true);
    }
  }

  hideScene() {
    getPet().position.setWandering(false);
  }

  private createNativeAppButton() {
    if (!isNativeAppAvailable()) {
      return;
    }

    const { energyLayout, energyIcon, energyRegenerationFrame } = uiConfig.hud;
    const button = this.getView().addSubview(
      new NativeAppPromoButton({
        x: 525,
        visible: false,
      }),
    );
    void statePromise(
      () => isSceneEntered('livingRoom') && isNativePromoAvailable(),
    ).then(async () => {
      let { y } = getSceneManager().header.getEnergyPos();
      y += energyLayout.height;
      y += energyRegenerationFrame.height;
      y -= energyIcon.height / 2;
      y -= getScreenTop();
      button.updateOpts({
        y,
        visible: true,
      });
    });
  }

  public transition(): Transition {
    return 'slide_back';
  }
}
